// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_c_p","cls2":"CoScientistPricingPage-cls2_UIS CoScientistPricingPage-cls1_c_p"};